import React, { Component } from "react";
import {Card, Button, Row, Col, Nav, Tab} from "react-bootstrap";
import { connect } from "react-redux";
import OverviewTab from "./tabs/OverviewTab";
import CalendarTab from "./tabs/CalendarTab";
import DocumentsTab from "./tabs/DocumentsTab";
import NotesTab from "./tabs/NotesTab";
import MedicationsTab from "./tabs/MedicationsTab";
import DrugTestsTab from "./tabs/DrugTestsTab";
import TransactionsTab from "./tabs/TransactionsTab";
import CheckinsTab from "./tabs/CheckinsTab";
import GoalsTab from "./tabs/GoalsTab";
import OutcomesTab from "./tabs/OutcomesTab/index";
import PaymentsTab from "./tabs/PaymentsTab/";
import TextField from "./fields/TextField";
import SelectField from "./fields/SelectField";
import SsnField from "./fields/SsnField";
import { buildOptions, sponsorOptions } from "./utils";
import GeneralFormModal from "./modals/GeneralFormModal";
import PasswordResetFormModal from "./modals/PasswordResetFormModal";
import { StickyContainer, Sticky } from "react-sticky";
import SignUpCodeButton from "./SignUpCodeButton";
import PasswordResetButton from "./PasswordResetButton";
import ProfilePicture from "./ProfilePicture";
import AutoSave from "./AutoSave";
import SaveButton from "./SaveButton";
import ModalButton from "./ModalButton";
import ErrorModal from "./ErrorModal";
import { intersection } from "lodash";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import { General } from "./staffApp/components/General";
import { staffAppEventTriggers } from "./staffApp/eventTriggers";
import { Contacts } from "./staffApp/components/Contacts";
import { FamilyMembers } from "./staffApp/components/FamilyMembers";
import { PublicBenefits } from "./staffApp/components/PublicBenefits";
import { Demographics } from "./staffApp/components/Demographics";
import { Doctors } from "./staffApp/components/Doctors";
import { Documents } from "./staffApp/components/Documents";
import { EducationHistory } from "./staffApp/components/EducationHistory";
import { Goals } from "./staffApp/components/Goals";
import { Insurances } from "./staffApp/components/Insurances";
import { MedicalHistory } from "./staffApp/components/MedicalHistory";
import { Medications } from "./staffApp/components/Medications";
import MedicationFormModal from "./Medications/MedicationFormModal";
import { RecoveryInformation } from "./staffApp/components/RecoveryInformation";
import { RecoveryHistory } from "./staffApp/components/RecoveryHistory";
import { PastOccupancies } from "./staffApp/components/PastOccupancies";
import { CurrentOccupancies } from "./staffApp/components/CurrentOccupancies";
import { saveProfileAction } from "./hooks";
import { DrugTests } from "./staffApp/components/DrugTests";
import EmploymentHistory from "./staffApp/components/EmploymentHistory";
import { SoberLivingHistory } from "./staffApp/components/SoberLivingHistory";
import { LivingArrangementHistory } from "./staffApp/components/LivingArrangementHistory";
import { TreatmentCenterHistory } from "./staffApp/components/TreatmentCenterHistory";
import { ChildWelfareHistory } from "./staffApp/components/ChildWelfareHistory";
import { Vaccines } from "./staffApp/components/Vaccines";
import { Tests } from "./staffApp/components/Tests";
import DateField from "./fields/DateField";
import AgeField from "./fields/AgeField";
import { ProbationHistory } from "./staffApp/components/ProbationHistory";
import { CounselingHistory } from "./staffApp/components/CounselingHistory";

class StaffAppErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Staff App Profile Error:", error, errorInfo);

    fetch("/log_js_error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error?.message,
        stack: error?.stack,
        source: "staff_app_resident_profile",
        component: errorInfo?.componentStack,
        url: window.location.href,
        resident_id: this.props.residentId,
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <p className="text-danger font-weight-bold">Something went wrong loading this profile.</p>
          <p className="text-muted small">{this.state.error?.message}</p>
          <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

class ResidentForm extends Component {
  state = {
    tabKey: "general",
    confirmDelete: false,
    referrals: this.props.referrals,
  };

  fetchReferrals = (filter_name = "") => {
    return $.ajax({
      url: `/organizations/${this.props.organization.name}/referrals.json?q[first_name_or_last_name_or_contact_org_cont]=${filter_name}&referral_id_to_include=${this.props.resident.referral_id}`,
    }).then((payload) => this.setState({ referrals: payload }));
  };

  resetPasswordModal = (e) => {
    this.props.openModal("passwordReset");
  };

  componentDidUpdate() {
    const { occupancies, organization } = this.props;

    this.props.setCurrentOccupancies(occupancies);
    this.props.setPastOccupancies(occupancies);
    this.props.setCanAddOccupancy(occupancies, organization);
  }

  componentDidMount() {
    const { permissions, isStaffApp } = this.props;
    this.fetchReferrals();
    function getActiveTabKey() {
      if (window.location.hash) {
        return window.location.hash.substr(1);
      } else if (
        intersection(permissions, ["process_payments"]).length > 0 &&
        intersection(permissions, ["use_client_profile"]).length == 0
      ) {
        return "payments";
      } else {
        return isStaffApp ? "general" : "overview";
      }
    }
    this.setState({
      tabKey: getActiveTabKey(),
    });
    isStaffApp &&
      this.props.toggleAction() &&
      staffAppEventTriggers(this.props, this.state, (state) =>
        this.setState(state)
      ) &&
      document.dispatchEvent(new CustomEvent("set-tab", { detail: "doctors" }));

    document.addEventListener("resetPassword", this.resetPasswordModal);
  }

  componentWillUnmount() {
    document.removeEventListener("resetPassword", this.resetPasswordModal);
  }

  listTabItems() {
    return <Nav variant="tabs" className='resident-tabs'>
      {this.props.tabs.map((tab) => {
        return (
          <Nav.Item>
            <Nav.Link eventKey={tab.value}>{tab.label}</Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  }
  dropDownTabItems() {
    // The staff app provides its own native section dropdown, so the in-webview
    // dropdown is redundant there (and receives no tabs). Render it for web only.
    if (this.props.isStaffApp) return null;
    // Use a native <select> rather than react-bootstrap's Dropdown: that beta
    // version's Dropdown relies on react-overlays/findDOMNode, which is unreliable
    // under the React 18 runtime here and was failing to open at all.
    return (
      <div className="resident-mobile-tabs">
        <select
          className="form-control resident-section-select"
          value={this.state.tabKey}
          onChange={(e) => this.setState({ tabKey: e.target.value })}
        >
          {this.props.tabs.map((tab) => (
            <option key={tab.value} value={tab.value}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  render() {
    const mentorOptions = this.props.mentors.map((mentor) => ({
      value: mentor.id,
      label: `${mentor.first_name} ${mentor.last_name}`,
    }));
    const referralOptions = this.state.referrals.map((referral) => ({
      value: referral.id,
      label: `${referral.first_name || ""} ${referral.last_name || ""} ${referral.contact_org ? `(${referral.contact_org})` : ""
        }`,
    }));
    const statusOptions = buildOptions(this.props.category_options);
    const {
      current_user,
      resident,
      organization,
      users,
      action,
      surveySubmissions,
      stripe_api_key,
      goal_subscriptions,
      permissions,
      isStaffApp,
    } = this.props;
    const services = organization.services_names;

    return (
      <StickyContainer>
        <ErrorModal />
        <ConfirmDeleteModal
          show={this.state.confirmDelete}
          handleHide={() => this.setState({ confirmDelete: false })}
          organization={organization}
          resident={resident}
        />
        <div id="resident" className='resident-form'>
          {intersection(permissions, ["use_client_profile"]).length > 0 &&
            !isStaffApp && (
              <Card>
                <Sticky>
                  {({ style }) => {
                    return (
                      <Card.Header
                        style={{ ...style, zIndex: 10 }}
                        className="d-md-flex justify-content-between align-items-center"
                      >
                        <div style={{ fontSize: 24, fontWeight: 'bold' }}>{`${resident.name}`}</div>
                        <div>
                          <AutoSave />
                        </div>
                        <div className="d-lg-flex justify-content-center align-items-center">
                          {intersection(permissions, [
                            "use_client_profile",
                            "edit_everything",
                          ]).length > 1 &&
                            organization["mobile_app?"] &&
                            action === "show" &&
                            !resident["has_active_user?"] && (
                              <SignUpCodeButton />
                            )}
                          {intersection(permissions, [
                            "use_client_profile",
                            "edit_everything",
                          ]).length > 1 &&
                            users.length > 0 && (
                              <div>
                                <PasswordResetButton />
                              </div>
                            )}
                          {intersection(permissions, [
                            "use_client_profile",
                            "edit_everything",
                          ]).length > 1 && (
                              <div>
                                <SaveButton />
                              </div>
                            )}
                        </div>
                      </Card.Header>
                    );
                  }}
                </Sticky>
                <div className="card-block">
                  <Row>
                    <Col className="d-md-block" sm={2}>
                      <ProfilePicture />
                    </Col>
                    <Col sm={10}>
                      <GeneralFormModal
                        referrals={this.state.referrals}
                        fetchReferrals={this.fetchReferrals}
                        show_ssn={resident.show_ssn}
                      />
                      <Row>
                        <TextField
                          name="first_name"
                          label="First Name"
                          action="show"
                        />
                        <TextField
                          name="middle_name"
                          label="Middle Name"
                          action="show"
                        />
                        <TextField
                          name="last_name"
                          label="Last Name"
                          action="show"
                        />
                        <TextField
                          name="pronoun"
                          label="Pronoun"
                          action="show"
                        />
                        <TextField
                          name="nickname"
                          label="Nickname/Preferred name"
                          action="show"
                        />
                        <TextField name="email" label="Email" action="show" />
                        <TextField
                          name="phone"
                          label="Phone"
                          action="show"
                          textDecorator={(text) => text.trim().replace("-", "")}
                        />
                        <DateField
                          name="birthdate"
                          label="Birthdate"
                          action="show"
                        />
                        <AgeField />
                        <TextField
                          name="mailing_address"
                          label="Mailing Address"
                          action="show"
                        />
                        <SelectField
                          name="mentor_ids"
                          label="Mentor"
                          options={mentorOptions}
                          action="show"
                        />
                        <SelectField
                          name="category_list"
                          label="Category"
                          options={statusOptions}
                          creatable
                          action="show"
                        />
                        <TextField
                          name="level"
                          label="Level/Phase/Tier"
                          action="show"
                        />
                        <TextField
                          name="client_number"
                          label="Client Number"
                          action="show"
                        />
                        {intersection(services, ["crm"]).length == 1 && (
                          <SelectField
                            name="referral_id"
                            label="Referral"
                            options={referralOptions}
                            creatable
                            action="show"
                          />
                        )}
                        <SelectField
                          name="sponsor"
                          label="Sponsor"
                          action="show"
                          options={sponsorOptions}
                        />
                        <TextField
                          name="occupation"
                          label="Occupation"
                          action="show"
                        />
                        <TextField
                          name="fullAddress"
                          label="Full Address"
                          action="show"
                          customValue={[this.props.resident.address, this.props.resident.city, this.props.resident.state, this.props.resident.zip].filter(Boolean).join(', ')}
                        />
                        <SsnField />
                        <TextField
                            name="criminal_arrest_history"
                            label="Criminal/Arrest History"
                            action="show"
                        />
                      </Row>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-center">
                    <ModalButton
                      resourceName="general"
                      label="Add/Edit General Details"
                    />
                  </div>
                </div>
              </Card>
            )}
          {users.length > 0 && <PasswordResetFormModal />}
          <Tab.Container
            activeKey={this.state.tabKey}
            onSelect={(tabKey) => this.setState({ tabKey })}
          >
            {this.listTabItems()}
            {this.dropDownTabItems()}
            <Tab.Content>
              {intersection(permissions, ["use_client_profile"]).length > 0 && (
                <Tab.Pane eventKey="overview" title="Overview">
                  <OverviewTab />
                </Tab.Pane>
              )}
              {intersection(permissions, ["use_client_profile"]).length > 0 &&
                isStaffApp && (
                  <StaffAppErrorBoundary residentId={this.props.resident.id}>
                    <Tab.Pane
                      eventKey="general"
                      title="General"
                      className="p-0"
                    >
                      <General
                        confirmDelete={() =>
                          this.setState({
                            confirmDelete: true,
                          })
                        }
                        permissions={permissions}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="past_occupancies"
                      className="p-0"
                      title="Past Occupancies"
                    >
                      <PastOccupancies />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="current_occupancies"
                      className="p-0"
                      title="Current Occupancies"
                    >
                      <CurrentOccupancies />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="contacts"
                      className="p-0"
                      title="Contacts"
                    >
                      <Contacts />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="family_members"
                      className="p-0"
                      title="Family Members"
                    >
                      <FamilyMembers />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="counseling_history"
                      className="p-0"
                      title="Counseling History">
                      <CounselingHistory/>
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="probations"
                      className="p-0"
                      title="Probation History"
                    >
                      <ProbationHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="child_welfare_history"
                      className="p-0"
                      title="Child Welfare History"
                    >
                      <ChildWelfareHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="recovery_information"
                      className="p-0"
                      title="Recovery Information"
                    >
                      <RecoveryInformation />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="recovery_history"
                      className="p-0"
                      title="Recovery History"
                    >
                      <RecoveryHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="medical_history"
                      className="p-0"
                      title="Medical History"
                    >
                      <MedicalHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="doctors"
                      className="p-0"
                      title="Doctors"
                    >
                      <Doctors />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="treatment_center_history"
                      className="p-0"
                      title="Treatment Center History"
                    >
                      <TreatmentCenterHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="sober_living_history"
                      className="p-0"
                      title="Sober Living History"
                    >
                      <SoberLivingHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="living_arrangement_history"
                      className="p-0"
                      title="Living Arrangement History"
                    >
                      <LivingArrangementHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="education_history"
                      className="p-0"
                      title="Education History"
                    >
                      <EducationHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="employment_history"
                      className="p-0"
                      title="Employment History"
                    >
                      <EmploymentHistory />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="demographics"
                      className="p-0"
                      title="Demographics"
                    >
                      <Demographics />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="insurances"
                      className="p-0"
                      title="Insurance"
                    >
                      <Insurances />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="vaccines"
                      className="p-0"
                      title="Vaccines"
                    >
                      <Vaccines />
                    </Tab.Pane>
                    <Tab.Pane eventKey="tests" className="p-0" title="Tests">
                      <Tests />
                    </Tab.Pane>
                  </StaffAppErrorBoundary>
                )}
              {intersection(permissions, [
                "process_payments",
                "client_profile_tab_payments",
              ]).length == 2 &&
                intersection(services, ["payments"]).length == 1 && (
                  <Tab.Pane eventKey="payments" title="Payments">
                    {this.state.tabKey === "payments" && 
                      <PaymentsTab
                        stripe_api_key={stripe_api_key}
                        resident={resident}
                        current_user={current_user}
                        organization={organization}
                      />
                    }
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_agenda",
              ]).length == 2 && (
                  <Tab.Pane
                    eventKey="calendar"
                    title="Agenda"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {this.state.tabKey === "calendar" && <CalendarTab />}
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_documents",
              ]).length == 2 && (
                  <Tab.Pane
                    eventKey="documents"
                    title="Documents"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {isStaffApp ? <Documents /> : this.state.tabKey === "documents" && <DocumentsTab isActive={this.state.tabKey === "documents"} />}
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_notes",
              ]).length == 2 && (
                  <Tab.Pane
                    eventKey="notes"
                    title="Notes"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {this.state.tabKey === "notes" && <NotesTab isActive={this.state.tabKey === "notes"} />}
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_medications",
              ]).length == 2 &&
                intersection(services, ["medical_logs"]).length == 1 && (
                  <Tab.Pane
                    eventKey="meds"
                    title="Meds"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    <MedicationFormModal />
                    {isStaffApp
                      ? this.state.tabKey === "meds" && <Medications />
                      : this.state.tabKey === "meds" && <MedicationsTab />}
                  </Tab.Pane>
                )}
              {organization.ua_ba &&
                intersection(permissions, [
                  "use_client_profile",
                  "client_profile_tab_ua_ba_results",
                ]).length == 2 &&
                intersection(services, ["ua_ba"]).length == 1 && (
                  <Tab.Pane
                    eventKey="uaba"
                    title="UA/BA Results"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {isStaffApp ? <DrugTests /> : <DrugTestsTab />}
                  </Tab.Pane>
                )}
              {((organization["sober_home?"] &&
                !organization["treatment_center?"]) ||
                (organization["sober_home?"] &&
                  organization["treatment_center?"])) &&
                intersection(permissions, [
                  "use_client_profile",
                  "client_profile_tab_money_log",
                ]).length == 2 &&
                intersection(services, ["money_log"]).length == 1 &&
                !isStaffApp && (
                  <Tab.Pane
                    eventKey="money_log"
                    title="Money Log"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    <TransactionsTab />
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_mobile_check_ins",
              ]).length == 2 &&
                users.length > 0 && (
                  <Tab.Pane
                    eventKey="mobile_activity"
                    title="Mobile Check Ins"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {this.state.tabKey === "mobile_activity" && 
                      <CheckinsTab 
                        isActive={this.state.tabKey === "mobile_activity"}
                        permissions={permissions}
                      />}
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_goals",
              ]).length == 2 && (
                  <Tab.Pane
                    eventKey="goals"
                    title="Goals"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    {isStaffApp ? <Goals /> : this.state.tabKey === "goals" && <GoalsTab isActive={this.state.tabKey === "goals"} />}
                  </Tab.Pane>
                )}
              {intersection(permissions, [
                "use_client_profile",
                "client_profile_tab_surveys",
              ]).length == 2 &&
                surveySubmissions.length > 0 && (
                  <Tab.Pane
                    eventKey="survey_submissions"
                    title="Surveys"
                    className={isStaffApp ? "p-0" : ""}
                  >
                    <OutcomesTab />
                  </Tab.Pane>
                )}
            </Tab.Content>
          </Tab.Container>
          {action === "edit" &&
            !isStaffApp &&
            intersection(permissions, ["delete_everything"]).length > 0 && (
              <>
                <Card className="card-outline-danger">
                  <Card.Header className="d-flex justify-content-between">
                    Delete Client
                    <Button
                      variant="danger"
                      onClick={() => this.setState({ confirmDelete: true })}
                    >
                      Delete Client
                    </Button>
                  </Card.Header>
                  <Card.Body className="card-block">
                    <p>Do this only if you are sure</p>
                  </Card.Body>
                </Card>
              </>
            )}
        </div>
      </StickyContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    current_user: state.current_user,
    resident: state.resident,
    mentors: state.mentors,
    action: state.ui.action,
    organization: state.organization,
    users: state.users,
    surveySubmissions: state.survey_submissions,
    permissions: state.permissions,
    category_options: state.org_dependant_data.category_options,
    referrals: state.org_dependant_data.referrals,
    goal_subscriptions: state.goal_subscriptions,
    tabs: state.tabs,
    config: state.config,
    occupancies: state.occupancies,
    canAddOccupancy: state.can_add_occupancy
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleAction: () => dispatch({ type: "TOGGLE_ACTION" }),
    saveProfile: () => dispatch(saveProfileAction()),
    openModal: (resourceName) => {
      dispatch({ type: "OPEN_RESOURCE_MODAL", payload: { resourceName } });
    },
    newResource: (resourceName) => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName },
      });
    },
    closeModal: (resourceName) => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName },
      });
    },
    editContact: (resourceName, resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName, resource },
      });
    },
    setCurrentOccupancies: (occupancies) => {
      dispatch({ type: 'SET_CURRENT_OCCUPANCIES', payload: { occupancies: occupancies } });
    },
    setPastOccupancies: (occupancies) => {
      dispatch({ type: 'SET_PAST_OCCUPANCIES', payload: { occupancies: occupancies } });
    },
    setCanAddOccupancy: (occupancies, organization) => {
      dispatch({ type: "SET_CAN_ADD_OCCUPANCY", payload: { occupancies, organization} });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResidentForm);
